import Approach from "./components/Approach";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import Nav from "./components/Nav";
import Products from "./components/Products";

const App = () => (
  <div id="top">
    <Nav />
    <main>
      <Hero />
      <Products />
      <Approach />
      <Contact />
    </main>
    <Footer />
  </div>
);

export default App;
